import WorkspacePageShell from "../../../components/WorkspacePageShell";

export default function HRPageShell(props) {
  return <WorkspacePageShell eyebrow="HR" {...props} />;
}
